// extracted by mini-css-extract-plugin
export default {"row":"place-offer_row__aIUb0","resultRow":"place-offer_resultRow__owhNK"};